import template from './labor-distribution-report.html';
import controller from './labor-distribution-report.controller';

let laborDistributionReportComponent = {
  restrict: 'E',
  template,
  controller
};

export default laborDistributionReportComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/labor-distribution-report/labor-distribution-report.component.js